'use strict';

var _ = require('lodash');

function ViewController (sbNavDrawerService) {

  var pageId = '';
  var viewManager = null;

  var DEFAULTS = {
    id: '',
    visible: false
  };

  _.defaults(this, DEFAULTS);

  this.init = function (_pageId) {
    pageId = _pageId;
    viewManager = sbNavDrawerService.getViewManager(pageId);
    this.index = viewManager.register(this.id);
  };

  this.getPos = function (viewId) {
    return viewManager.getViewIndex(viewId);
  };
}

module.exports = ViewController;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/layout/src/nav/view/ViewController.js